import { Loader2 } from 'lucide-react'
import clsx from 'clsx'

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10" role="status" aria-live="polite">
      <Loader2 className={clsx('h-8 w-8 animate-spin text-primary-500', className)} aria-hidden />
      {label && <p className="text-sm text-night-300">{label}</p>}
    </div>
  )
}
export default Spinner
